import request from './request'

let currentUserRole = null
let rolePromise = null

/**
 * 获取当前用户角色
 * @returns {Promise<string>} 用户角色
 */
export const getCurrentUserRole = async () => {
    if (currentUserRole) {
        return currentUserRole
    }

    if (rolePromise) {
        return rolePromise
    }

    rolePromise = new Promise(async (resolve, reject) => {
        try {
            const response = await request.get('/user/current-role')
            if (response.code === '200') {
                currentUserRole = response.data
                resolve(currentUserRole)
            } else {
                console.error('获取用户角色失败:', response.message)
                reject(new Error(response.message || '获取用户角色失败'))
            }
        } catch (error) {
            console.error('获取用户角色错误:', error)
            reject(error)
        } finally {
            rolePromise = null
        }
    })

    return rolePromise
}

/**
 * 检查是否是超级管理员
 * @returns {Promise<boolean>}
 */
export const isSuperAdmin = async () => {
    try {
        const role = await getCurrentUserRole()
        return role === 'SUPERADMIN'
    } catch (error) {
        console.error('检查超级管理员权限失败:', error)
        return false
    }
}

/**
 * 检查是否是普通用户
 * @returns {Promise<boolean>}
 */
export const isNormalUser = async () => {
    try {
        const role = await getCurrentUserRole()
        return role === 'NORMALUSER'
    } catch (error) {
        console.error('检查普通用户权限失败:', error)
        return false
    }
}

/**
 * 检查是否是企业管理员
 * @returns {Promise<boolean>}
 */
export const isEnterpriseAdmin = async () => {
    try {
        const role = await getCurrentUserRole()
        return role === 'ENTERPRISEADMIN'
    } catch (error) {
        console.error('检查企业管理员权限失败:', error)
        return false
    }
}

/**
 * 清除缓存的用户角色
 */
export const clearUserRoleCache = () => {
    currentUserRole = null
    rolePromise = null
}